export interface INewSessionArgsDTO {
  environment?: string;
  version?: string;
}
